<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab active>
                <template slot="title">
                    <i class="fa fa-user mr-2"></i>{{Core.Definition.getDefinition('Mon profil')}}
                </template>
                <DynamicForm
                        ref="dynamicForm"
                        getRoot="/user/profile"
                        saveRoot="/user/profile"
                        @onTrashClick="onTrashClick"
                        :formStructure="dataFormStructures.user">
                </DynamicForm>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-cogs mr-2"></i>{{Core.Definition.getDefinition('Mes paramètres')}}
                </template>
                <div class="p-2">
                    <router-view></router-view>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    import DynamicForm from '../../components/DynamicForm'
    import OrderList from './OrderList'
    import RecurringSubscriptionList from './RecurringSubscriptionList'
    import LimitedSubscriptionList from './LimitedSubscriptionList'
    import EventDateBookingList from './EventDateBookingList'
    export default {
        name: 'UserProfile',
        components: {
            LimitedSubscriptionList,
            RecurringSubscriptionList,
            EventDateBookingList,
            DynamicForm,
            OrderList
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    user: {
                        rows: [
                            {
                                cols: [
                                    {
                                        class: 'card-columns',
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Général'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'firstname'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'lastname'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'birthDate'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'lang'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'phone'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'mobile'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'email'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Coordonnées'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'address'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'country'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'province'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'city'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'zipcode'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title1'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingAddress'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCountry'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingProvince'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCity'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingZipcode'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Authentification'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'branchId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'password'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'avatar'
                                                                    }
                                                                ]
                                                            },
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'firstname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Prénom'),
                                value: ''
                            },
                            {
                                id: 'email',
                                type: 'email',
                                label: Core.Definition.getDefinition('Courriel'),
                                value: ''
                            },
                            {
                                id: 'lastname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Nom de famille'),
                                value: ''
                            },
                            {
                                id: 'phone',
                                type: 'phone',
                                label: Core.Definition.getDefinition('Téléphone'),
                                value: ''
                            },
                            {
                                id: 'mobile',
                                type: 'phone',
                                label: Core.Definition.getDefinition('Mobile'),
                                value: ''
                            },
                            {
                                id: 'birthDate',
                                type: 'date',
                                label: Core.Definition.getDefinition('Date de naissance'),
                                value: ''
                            },
                            {
                                id: 'branchId',
                                type: 'select',
                                required: true,
                                invalidFeedbackMessage: Core.Definition.getDefinition('Vous devez sélectionner une succursale par défaut.'),
                                label: Core.Definition.getDefinition('Succursale par défaut'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'lang',
                                type: 'select',
                                required: true,
                                label: Core.Definition.getDefinition('Langue'),
                                value: {value: 'fr-CA', label :'Français'},
                                onSelect: function() {}
                            },
                            {
                                id: 'address',
                                type: 'text',
                                label: Core.Definition.getDefinition('Adresse'),
                            },
                            {
                                id: 'country',
                                type: 'country',
                                label: Core.Definition.getDefinition('Pays'),
                                required: false,
                                value: {value: 'CA', label :'Canada'},
                                onSelect: function(value, form, fieldRefs) {
                                    if (value !== null && value.value !== undefined) {
                                        fieldRefs['province'].retrieve(value.value)
                                    } else {
                                        fieldRefs['province'].dataValue = null
                                    }
                                }
                            },
                            {
                                id: 'province',
                                type: 'province',
                                value: {value: 'QC', label :'Quebec'},
                                label: Core.Definition.getDefinition('Province'),
                                required: false,
                                onSelect: function() {}
                            },
                            {
                                id: 'city',
                                type: 'text',
                                label: Core.Definition.getDefinition('Ville'),
                            },
                            {
                                id: 'zipcode',
                                type: 'text',
                                label: Core.Definition.getDefinition('Code Postal'),
                            },
                            {
                                id: 'billingAddress',
                                type: 'text',
                                label: Core.Definition.getDefinition('Adresse'),
                            },
                            {
                                id: 'billingCountry',
                                type: 'country',
                                label: Core.Definition.getDefinition('Pays'),
                                required: false,
                                value: {value: 'CA', label :'Canada'},
                                onSelect: function(value, form, fieldRefs) {
                                    if (value !== null && value.value !== undefined) {
                                        fieldRefs['billingProvince'].retrieve(value.value)
                                    } else {
                                        fieldRefs['billingProvince'].dataValue = null
                                    }
                                }
                            },
                            {
                                id: 'billingProvince',
                                type: 'province',
                                value: {value: 'QC', label :'Quebec'},
                                label: Core.Definition.getDefinition('Province'),
                                required: false
                            },
                            {
                                id: 'billingCity',
                                type: 'text',
                                label: Core.Definition.getDefinition('Ville'),
                            },
                            {
                                id: 'billingZipcode',
                                type: 'text',
                                label: Core.Definition.getDefinition('Code Postal'),
                            },
                            {
                                id: 'avatar',
                                type: 'avatar',
                                label: Core.Definition.getDefinition('Photo')
                            },
                            {
                                id: 'password',
                                type: 'password',
                                autoGenerateOption: true,
                                readable: true,
                                label: Core.Definition.getDefinition('Mot de passe')
                            },
                            {
                                id: 'title1',
                                type: 'title',
                                tag: 'h6',
                                label: Core.Definition.getDefinition('Informations de facturation')
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            addOrder() {
                this.$router.push(Core.Text.format(Core.Definition.getDefinition('/commerce/commandes/nouvelle-commande/{0}'), this.dataId))
            },
            addRecurring() {
                this.$router.push(Core.Text.format(Core.Definition.getDefinition('/commerce/abonnements-recurrents/nouvel-abonnement/{0}'), this.dataId))
            },
            addLimited() {
                this.$router.push(Core.Text.format(Core.Definition.getDefinition('/commerce/abonnements-limites/nouvel-abonnement/{0}'), this.dataId))
            }
        }
    }
</script>
